<template>
  <div class="personal-works">
    <h1 class="section-title">个人习作分享</h1>
    
    <div class="works-gallery">
      <!-- 习作1 -->
      <div class="work-item">
        <div class="work-image">
          <img v-if="works[0].image" :src="works[0].image" alt="行书习作">
          <div v-else class="loading-placeholder">加载中...</div>
        </div>
        <div class="work-info">
          <h3>行书习作</h3>
          <p class="work-date">2024年春</p>
          <p class="work-description">临摹王羲之《兰亭序》，练习行书笔法与结构。</p>
        </div>
      </div>
      
      <!-- 习作2 -->
      <div class="work-item">
        <div class="work-image">
          <img v-if="works[1].image" :src="works[1].image" alt="楷书习作">
          <div v-else class="loading-placeholder">加载中...</div>
        </div>
        <div class="work-info">
          <h3>楷书习作</h3>
          <p class="work-date">2024年夏</p>
          <p class="work-description">临摹欧阳洵《九成宫醴泉铭》，练习楷书基本功。</p>
        </div>
      </div>
      
      <!-- 习作3 -->
      <div class="work-item">
        <div class="work-image">
          <img v-if="works[2].image" :src="works[2].image" alt="篆书习作">
          <div v-else class="loading-placeholder">加载中...</div>
        </div>
        <div class="work-info">
          <h3>篆书习作</h3>
          <p class="work-date">2024年秋</p>
          <p class="work-description">学习石鼓文，感受篆书的古朴韵味。</p>
        </div>
      </div>
    </div>
    
    <div class="practice-notes">
      <h2>习书心得</h2>
      <div class="notes-content">
        <p>书法是一门需要长期坚持的艺术，每一次练习都是对心性的磨练。初学书法时，我从楷书入手，注重基本功的训练，体会点画的形态和结构的安排。</p>
        <p>随着学习的深入，我开始尝试行书和草书，感受不同书体的特点和韵味。在临摹经典作品的过程中，我不仅学习了前人的笔法和章法，更体会到了书法中蕴含的文化内涵。</p>
        <p>书法艺术讲究"字外功夫"，除了勤加练习，还需要提高自身的文化素养和审美能力。我会继续努力，在书法艺术的道路上不断探索和前进。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalWorks',
  data() {
    return {
      works: [
        { image: '' },
        { image: '' },
        { image: '' }
      ]
    }
  },
  mounted() {
    this.loadImages()
  },
  methods: {
    async loadImages() {
      const imageUrls = [
        '/image/api/index.php?apikey=1c17b11693cb5ec63859b091c5b9c1b2&action=get&file=cursive_practice',
        '/image/i/2026/04/03/nfdc8j.jpg',
        '/image/api/index.php?apikey=1c17b11693cb5ec63859b091c5b9c1b2&action=get&file=seal_practice'
      ]
      
      for (let i = 0; i < imageUrls.length; i++) {
        try {
          const response = await fetch(imageUrls[i])
          const blob = await response.blob()
          const reader = new FileReader()
          reader.onload = (e) => {
            this.$set(this.works, i, { image: e.target.result })
          }
          reader.readAsDataURL(blob)
        } catch (error) {
          console.error('加载图片失败:', error)
        }
      }
    }
  }
}
</script>

<style scoped>
.personal-works {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.section-title {
  font-size: 2.5em;
  color: #333;
  text-align: center;
  margin-bottom: 60px;
  font-family: 'SimSun', serif;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 100px;
  height: 3px;
  background: #999;
  margin: 20px auto;
}

.works-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-bottom: 60px;
}

.work-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;
}

.work-item:hover {
  transform: translateY(-5px);
}

.work-image {
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.work-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.loading-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  color: #999;
  font-size: 14px;
}

.work-info {
  padding: 20px;
}

.work-info h3 {
  font-size: 1.3em;
  color: #333;
  margin-bottom: 10px;
  font-family: 'SimSun', serif;
}

.work-date {
  font-size: 0.9em;
  color: #999;
  margin-bottom: 15px;
}

.work-description {
  color: #666;
  line-height: 1.5;
  font-size: 0.95em;
}

.practice-notes {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 40px;
}

.practice-notes h2 {
  font-size: 1.8em;
  color: #333;
  margin-bottom: 20px;
  font-family: 'SimSun', serif;
  text-align: center;
}

.notes-content p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
  text-indent: 2em;
  font-size: 1.05em;
}

@media (max-width: 768px) {
  .works-gallery {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .work-image {
    height: 200px;
  }
  
  .section-title {
    font-size: 2em;
  }
  
  .practice-notes {
    padding: 20px;
  }
  
  .practice-notes h2 {
    font-size: 1.5em;
  }
}
</style>